import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import {
  postAPI_ResetPin,
  postAPI_VerifyForgotPassword,
} from '../../constants/APIs';
import aiva_logo from '../../assets/aiva_logo.png';
import { NotificationManager } from '../../components/common/react-notifications';
import queryString from 'query-string';
export default class ResetPin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      reason: 'ForgotFlow',
      password: '',
      creator: 'user',
      formShow: true,
      loginbutton: false,
      loading: false,
      process: false,
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);    
    let data = { data: values.data };
    //  let data = { data: '0NiGF6C1xZBMmcBKNYAHS9BIj0xiavhLqxcVIc171ZcbW/SGhZ9WJLfc/YArjeWrdscqFBgUETavWKanZLfsafTGEpkq+oSRYzCUvAFxDZ+tT+NGk2o+NFCIY1BzH3/p+aGb9HAOwiew35OUMR+Fyw==' };
    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_VerifyForgotPassword}`,
      data: data,
    }).then(
      (res) => {
        this.setState({ id: res.data.id });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  handleChangePassword = (password) => {
    this.setState({
      password: password.target.value,
    });
  };

  onUserResetPassword() {
    this.setState({ process: true, loading: true });
    let data = {
      reason: 'ForgotFlow',
      pin: this.state.password,
      creator: 'user',
    };

    AxiosPublicAPI({
      method: 'put',
      url: `${postAPI_ResetPin}/${this.state.id}/change-pin`,
      data: data,
    }).then(
      (res) => {
        this.setState({
          formShow: false,
          loginbutton: true,
        });
        // NotificationManager.success(
        //   'Password Reset Successfully',
        //   'Password Reset Success',
        //   3000,
        //   null,
        //   null,
        //   'success'
        // );
        this.setState({ loading: false });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }
  onGoLogin() {
    window.location.href = 'https://app.getaiva.com';
  }
  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">
               a voucher distribution system for savvy tourism businesses
              </p>
              <p className="white mb-0">Please enter the new password.</p>
            </div>
            <div className="form-side">
              {!this.state.process && (
                <Fragment>
                  <NavLink to={`/`} className="white">
                    <span class="logo-single">
                      {' '}
                      <img
                           src={aiva_logo}
                           width="150"
                      />{' '}
                    </span>
                  </NavLink>
                  <CardTitle
                    className="mb-4"
                    style={{ display: this.state.formShow ? 'block' : 'none' }}
                  >
                    Reset Pin
                  </CardTitle>
                  <Form
                    style={{ display: this.state.formShow ? 'block' : 'none' }}
                  >
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        type="password"
                        onChange={this.handleChangePassword}
                      />
                      <IntlMessages id="user.newpin" />
                    </Label>
                    <Label className="form-group has-float-label mb-4">
                      <Input type="password" />
                      <IntlMessages id="user.newpinagain" />
                    </Label>
                    <div className="d-flex justify-content-end align-items-center">
                      <Button
                        color="primary"
                        className="text-white"
                        size="lg"
                        onClick={() => this.onUserResetPassword()}
                      >
                        <IntlMessages id="user.reset-password-button" />
                      </Button>
                    </div>
                  </Form>
                </Fragment>
              )}
              {this.state.process &&
                (this.state.loading ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                    <p>Your request is in progress</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <h2 className="mb-5">Pin successfully reset</h2>
                    <p className="mb-2">
                      You have successfully reset your pin
                    </p>
                    <a>
                      {' '}
                      <div
                        className="text-primary text-small font-weight-medium d-none d-sm-block"
                        onClick={() => this.onGoLogin()}
                      >
                        Return to log in screen
                      </div>{' '}
                    </a>
                  </div>
                ))}
              {/* {this.state.loginbutton === true && (
                <Form>
                  <Button
                    onClick={() => this.onGoLogin()}
                    color="primary"
                    size="lg"
                    className="btn-shadow"
                  >
                    <IntlMessages id="user.login-button" />
                  </Button>
                </Form>
              )} */}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
